module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-components/side-nav/side-nav.component.css
// module id = ./src/app/ui-components/side-nav/side-nav.component.css
// module chunks = main